"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Home = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const Home = () => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    (0, react_1.useEffect)(() => {
        const statusCode = window.moneraStatusCode;
        const tenant = window.moneraTenant;
        if (statusCode) {
            (0, metric_helper_1.meterStatusCode)({ statusCode, tenant, methodName: 'Home', requestId: configStoreState.requestId });
        }
    });
    return (react_1.default.createElement("div", null, "You've hit the Monera service, please route to url with path like /dp/[asin] (ie. /dp/BT6SB4SCV3)"));
};
exports.Home = Home;
__exportStar(require("./_app"), exports);
__exportStar(require("./_document"), exports);
__exportStar(require("./_error"), exports);
__exportStar(require("./dp/[asin]"), exports);
__exportStar(require("./thank-you"), exports);
